import '../vendor';

import '../general/ofi';
import '../general/btn-up';
import '../general/sharer.min';
import '../general/tabs';

import './promo/modal-full-screen';
import './promo/tile-accordion';
import './promo/gallery-scroll';
import './promo/links-scroll';
import './promo/menu';
import './promo/tile-four';
import './promo/donation';
import './promo/lead-validation';

import '../visually-impaired/open';
import '../visually-impaired/click';
import '../visually-impaired/size';
import '../visually-impaired/color';
import '../visually-impaired/length';
import '../visually-impaired/image';


// WEBPACK FOOTER //
// ./src/js/pages/promo.js